import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { MenuController } from '@ionic/angular';
import { Subject } from 'rxjs';
import { BackButtonService } from 'src/app/services/back-button.service';

@Component({
  selector: 'app-check-stock-page',
  templateUrl: './check-stock-page.component.html',
  styleUrls: ['./check-stock-page.component.scss'],
})
export class CheckStockPageComponent {
  public loading = true;
  public backUrl = '';
  private destroyed$ = new Subject<void>();

  constructor(
    private menuCtrl: MenuController,
    private backButtonService: BackButtonService,
    private router: Router
  ) {}
  public ngOnInit(): void {
    this.loading = false;
    this.backUrl = this.router.url;
    this.backButtonService.hideBackButton();
  }

  public ngOnDestroy(): void {
    this.destroyed$.next();
    this.destroyed$.complete();
  }
  ionViewWillEnter() {
    this.menuCtrl.close();
  }
}
